/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.02.25 10:05.
* @Author
* @Description 数据
**/
/**
 *@Description
 *@Param
 *@Return 年级.
 **/
export const gradeData = [{
  id: '0',
  name: '全部'
}, {
  id: 'b2dd792ed0444323ac00d586e2c67561',
  name: '小班'
}, {
  id: '86be38455b41410fb1354d66f92e5f3f',
  name: '中班'
}, {
  id: '79eda5ad7fc04b4b878bbbb71168fb09',
  name: '大班'
}, {
  id: '161e1619b4384b2f8602fbddc0da7a06',
  name: '一年级'
}, {
  id: '5157dc3d79ec4583a9ba480d3194af74',
  name: '二年级'
}, {
  id: 'c23948048f9e4a06bf1b45192432c35e',
  name: '三年级'
}, {
  id: 'c0d7488458684240aebc5514e81b3f4a',
  name: '四年级'
}, {
  id: 'e762e8bbad364484a219eb42b5019915',
  name: '五年级'
}, {
  id: '54466503df394404850123ed08be6cda',
  name: '六年级'
}, {
  id: '2b0411f5fd524e8e89aa4073e915aeb7',
  name: '初一'
}, {
  id: '1c614261319644858eb67d26c423833f',
  name: '初二'
}, {
  id: '0d4cab9bd1aa44a486e622d55d19a912',
  name: '初三'
}, {
  id: '6df59f9a306c4b2aaab658978be8d9c2',
  name: '高一'
}, {
  id: '2dcffca0866849e7b93df3257dd5ebb7',
  name: '高二'
}, {
  id: 'db09c84bef47442099a24145cc729e5b',
  name: '高三'
}, {
  id: '77780582010e4803a750bd0b71a7f4e0',
  name: '大一'
}, {
  id: 'ec5633eca66b4c28902999ffa022faf0',
  name: '大二'
}, {
  id: 'c55c418a8b4c44669314a4d24c4e5dde',
  name: '大三'
}, {
  id: '1ab20ba8be274eccb55cd98d7a43f970',
  name: '大四'
}, {
  id: '41533c30fc844dbb8bf2c1afde37b731',
  name: '中职一年级'
}, {
  id: '10ecaf82122f4c6d8e6358eced12ec37',
  name: '中职二年级'
}, {
  id: 'abb7a893eb9e461c9e572745dfbe69f2',
  name: '中职三年级'
}]
/**
 *@Description
 *@Param
 *@Return 学科.
 **/
export const subjectData = [{
  id: '0',
  name: '全部'
}, {
  id: '4d80c6d16dea4cb4a628526903ff9a3e',
  name: '校本1'
}, {
  id: '81433e17f74142db977b40bc3198692e',
  name: '科学'
}, {
  id: 'd0d590d4df784260a47091399ae53895',
  name: '语言'
}, {
  id: 'd973dc3106ee452db78cf166917d7366',
  name: '健康'
}, {
  id: '8ad19cbe051d4838b37f65d5edb1243a',
  name: '社会'
}, {
  id: 'ade3d7c567fa474f850656fd334ce1ac',
  name: '艺术'
}, {
  id: '201bb93d2a274328b46a4c96552369d2',
  name: '音乐'
}, {
  id: 'b36112c0355f44949a9b1ead931ab370',
  name: '美术'
}, {
  id: 'f5074eaa0b364bb188c0c152500f9ff9',
  name: '全科一'
}, {
  id: '35a63881347845b6a15179318afd31d1',
  name: '全科二'
}, {
  id: '33d6a0f0b0e84f7bb99c4a226f15ea9a',
  name: '全科三'
}, {
  id: '58efa400c9e74bc2afe94b9c5c229f4f',
  name: '数学'
}, {
  id: '38508850dd1f4a5cac0aa5db216a6ccd',
  name: '绘本'
}, {
  id: '6e31807f7333491392bd46c6d059f0df',
  name: '幼儿'
}, {
  id: 'c7885b6df1384ecd83f63f46da3bc4db',
  name: '历史'
}, {
  id: 'f6c4e3b0a05e4d0b9e1f56cee921b436',
  name: '地理'
}, {
  id: '549417c2b59747659b79a9242dde59be',
  name: '安全教育'
}, {
  id: '7dfacb74a2424084ac1dc55d1d18a03c',
  name: '法制教育'
}, {
  id: '274d682baf5544e992dfd6ea974f734a',
  name: '影视教育'
}, {
  id: 'fb4bad6e3f074d0fbe90bcc55ceec0dc',
  name: '语文'
}, {
  id: 'c5b1ded2224344ab93b82473103b1f4b',
  name: '英语'
}, {
  id: 'a4420200b4424bf9be2611d4ef0ded1b',
  name: '体育'
}, {
  id: '1d4fc4c8d851433ea6dc82b6567026f6',
  name: '书法'
}, {
  id: '80547b2350c24ed9a39b0f59d87bea8d',
  name: '经诵'
}, {
  id: '2adc8c2af7ae4a3ba3f371a7ae47bfc1',
  name: '综合'
}, {
  id: 'b2327e4a144f4d16940cad404412001a',
  name: '信息技术'
}, {
  id: 'a0594458a5fc4b1f807e5f0b4590f99b',
  name: '思想品德'
}, {
  id: 'c557d25dc23e4535b456803ac611d8aa',
  name: '汉语'
}, {
  id: '6a22446f63564f8eb312975d174fbb23',
  name: '阅览'
}, {
  id: '06ff22a322b74b3eaf19590d76f9d04b',
  name: '校本课程'
}, {
  id: 'c1669a09086d4d49a37f7f1ffcaa9c6b',
  name: '校本教研'
}, {
  id: 'd4857aea06ae4b0281ba9225d153fcfa',
  name: '发现与探索'
}, {
  id: '03cf65642d5a4a4cb113ab3da925f1a6',
  name: '道德与法治'
}, {
  id: '61be84c05363407d9578b3da07438daf',
  name: '心理'
}, {
  id: 'fa82f1b3755c4e3db8823fc0e0b53b45',
  name: '梦想'
}, {
  id: '2a2057dbc6674a4b84e2f57b5301d4ee',
  name: '写字'
}, {
  id: 'c5aa0a6d1be74b048766c12b9ab259d2',
  name: '劳动'
}, {
  id: 'a00b7deacaee45d6a60e790cfefc3e29',
  name: '文体活动'
}, {
  id: '706ff6e7f3f049619a233ada2d29f199',
  name: '研究性学习'
}, {
  id: '717588d856b94f828d95890c3bb4587b',
  name: '地方课程'
}, {
  id: '192c23fa57034007bb8900e557de8718',
  name: '射箭'
}, {
  id: '1b1677ce4cbc4580a4486975b9717817',
  name: '生物'
}, {
  id: 'b386459ef123409a837ba8e8893ba983',
  name: '品德与社会'
}, {
  id: '5f25dd962e234449ae05c49098f6fc46',
  name: '品德与生活'
}, {
  id: '7dac0fa6fc244a8da4d42c0a6a6faa32',
  name: '体育与健康'
}, {
  id: '17anhui',
  name: '思想政治'
}, {
  id: 'a46621807e544b23bdf753d9f8cd4955',
  name: '天津与世界'
}, {
  id: 'bbe08f5b8eb843bda4381d11d492d816',
  name: '物理'
}, {
  id: '77f741f4c3984751b7260c208b8efefd',
  name: '化学'
}, {
  id: '06a7e54432574537986765b0d0aba840',
  name: '政治'
}, {
  id: '30f98a1501f545989e146835d706b5c3',
  name: '通用技术'
}, {
  id: 'ec9f35c3d48442bab4145ea7704c8bca',
  name: '历史与社会'
}, {
  id: '778b8187f6614ab18e493660bab907e0',
  name: '综合实践'
}, {
  id: 'aac354c9f7464231b3266af6dfeda21b',
  name: '劳动技术'
}, {
  id: 'b1e5a1196a484c2684c85fdfbcfd5038',
  name: '其他'
}, {
  id: '29bcb409cacb4406a90f84ef09db0d14',
  name: '版本培训'
}, {
  id: '4117fc5234e74cc08c01cef830b499eb',
  name: '全科'
}, {
  id: '4ea5384bdff34f45bf5ca568a1ae46b7',
  name: '外语'
}, {
  id: '4c0f18e25ee34cb1b0dc65738392975b',
  name: '综研'
}, {
  id: 'c0c8907049f84f17a0616a8ab8249f48',
  name: '黑龙江人文与社会'
}, {
  id: 'debf562d9a7e42c8bebc12d4e6f4ec6a',
  name: '技术'
}, {
  id: '9a8488bb19c94e369f2dbd943a62020a',
  name: '生命教育'
}, {
  id: 'b20b714f480242648e2fc71ddf924d8d',
  name: '中华大家庭'
}, {
  id: '2e4192c50e3b49ebbdd8e7405d9c871e',
  name: '自然'
}, {
  id: '5723b07f175349079b34f1d883712d00',
  name: '地英'
}, {
  id: '24800dd883284c9f8d9afcf2b7953d15',
  name: '民族常识'
}, {
  id: '9e726b3e61e1443fa9b68265e8379640',
  name: '品社'
}, {
  id: 'b17ecf6c2a71439a8771f5326d7ba4c1',
  name: '学校课程'
}, {
  id: '56ce4227ad794e4da0b04790718110ff',
  name: '计算机'
}, {
  id: '03a7f220f2984576875cf4620ae5f5d7',
  name: '信息'
}, {
  id: '8a8ddb4e27504e2796b7ea540e7ce747',
  name: '班会'
}, {
  id: '2be31265628e4d2f8468d75d4f74f883',
  name: '生命科学'
}, {
  id: 'c9acb07db0444474ae3693aba477df3d',
  name: '心理学'
}, {
  id: '45471b3a17754e1cabe08e47a5b1f1d7',
  name: '烹饪'
}, {
  id: '0c6e8b0e5f414d4eafc82b9e4121ab3f',
  name: '机电'
}, {
  id: '26cfaebc60a64b8786c5959bfc1182a3',
  name: '财经'
}, {
  id: 'f7a698194992498fb3f418aa5d7df1a4',
  name: '文化课'
}, {
  id: '86410b33132b4d508915bf4ddbdb5b6b',
  name: '电子'
}]
/**
 *@Description
 *@Param
 *@Return 版本.
 **/
export const editionData = [{
  id: '0',
  name: '全部'
}, {
  id: 'c5829ddaaf7a446988ea1add5a59bc8e',
  name: '教育科学出版社'
}, {
  id: '6a3dd3da4e38462bb1d10c5499862304',
  name: '广东科技出版社'
}, {
  id: 'fcdb082ddfe34d62a5075088ca5aa305',
  name: '花城粤教版'
}, {
  id: 'd2726e68f3fb4b609426c863d85a9933',
  name: '新人教课标版'
}, {
  id: '0450bbc24b674894ab850aaaf99e0a52',
  name: '陕人教版'
}, {
  id: '1d9e241262c54c67a1055751415bcfba',
  name: '华东师大版'
}, {
  id: '7bdae0c00ce2480292fd1573e58ec96f',
  name: '甘教版'
}, {
  id: 'd6ef2e1d9e1940c594fbc5e79eb25845',
  name: '北师大版'
}, {
  id: '6fb78f233c394999b6f8e70799cae1d8',
  name: '湘美版'
}, {
  id: 'b14ad3a5f9b1420f976bdc0ce41224ba',
  name: '北京语文出版社S版'
}, {
  id: '1426b7aceb434152ae0fbd8fc102125d',
  name: '牛津译林版'
}, {
  id: '7bdcab1add134a10999ee116e535c710',
  name: '粤教版'
}, {
  id: '7a20b5831b0645a0a40062dd74e753b2',
  name: '牛津上海版'
}, {
  id: 'f2980df1e80c4fdfafaf2ad13449cdd1',
  name: '岳麓版'
}, {
  id: 'd9fd2d7f255740b99b2a128a25691285',
  name: '人民版'
}, {
  id: '0e609e4c89c04a6693aa2ced24bb27eb',
  name: '校本教材'
}, {
  id: '13453158df96451eb4b72cde041586ed',
  name: '语文出版'
}, {
  id: '13b8cdadab4c4b499629db06a33bfc64',
  name: '新世纪版'
}, {
  id: 'ec0b5d0b241a4ba0b4886fe60d878373',
  name: '牛津深圳版'
}, {
  id: '3e55dc79e69f4ba59baa8dc6beeab370',
  name: '浙教版'
}, {
  id: 'b720a3b9db0447009d6637b512fc232f',
  name: '接力版'
}, {
  id: '973236c8c2284649a021103e74dd12d8',
  name: '鲁教版'
}, {
  id: '637650418ca040c5a2a5d1802d11906b',
  name: '清华大学出版社'
}, {
  id: '63453ee0e7c1477eb67954205d5e57ca',
  name: '苏教版'
}, {
  id: '3857a37da0ac4773be297dd5d5d6c43e',
  name: '川版'
}, {
  id: '6074f74d0ca4489fb81230b98f55dd46',
  name: '西南师范学院出版社'
}, {
  id: 'bfd8cb1d9f28429bb6dbaeae4404428b',
  name: '沪教版'
}, {
  id: 'b4bb63305c8e4e44b03b396216cd6c35',
  name: '外研社版'
}, {
  id: 'd4da16202bb94d0a82443f4943b5178f',
  name: '教科版'
}, {
  id: '5f05f0e11467450791c1256c18c9cfa9',
  name: '人美版'
}, {
  id: 'c809b52fddca4cff9c1f19d59b5d85c4',
  name: '外研版'
}, {
  id: 'f398967ccb3d44cf970a2422cbcab411',
  name: '人音版'
}, {
  id: '1e8acdb7fca64370b4098f8f4e37a621',
  name: '江苏少年儿童'
}, {
  id: '07889551356d4fdb8bc6709e1aaeed02',
  name: '黑龙江教育'
}, {
  id: 'd9cf05e3a16643f78dc5d90571f83552',
  name: '湖南教育出版'
}, {
  id: '4658c2d92543403dbb9ec5ba0e1f6afa',
  name: '山东教育'
}, {
  id: '2c56683bb45a446fb56c4f620a87f39a',
  name: '湖南美术'
}, {
  id: '5b3c0b59393b4cc6aa93f2b18372eaa0',
  name: '人教A版'
}, {
  id: '6998bd4b8f894d1e928f610a7a6ac2a6',
  name: '教育科学'
}, {
  id: 'f877742119f64b9ab8694b50436fb6f2',
  name: '岳麓书社版'
}, {
  id: 'a8e1a42c1b734367a8e8e95442c99898',
  name: '广东人民'
}, {
  id: 'ed43e237b5cc469fb434b42ab26b8fae',
  name: '红旗出版社'
}, {
  id: 'cd45a1c0053648828949a65a30ad17c9',
  name: '上海科技教育'
}, {
  id: 'a2b7e09b3d2546e4ab0b841654f07cce',
  name: '科学普及（仁爱版）'
}, {
  id: '88d592f5114d43ccbc6ab17e6e91a435',
  name: '中图版'
}, {
  id: 'd4b329f180b3455e83a075cd57bccc57',
  name: '人教版'
}]
/**
 *@Description
 *@Param
 *@Return 分类.
 **/
export const classificationData = [{
  id: '0',
  name: '全部 '
}, {
  id: '788958755c1943a283abaa0fe7046da8',
  name: '课堂实录'
}, {
  id: 'd021a81fba0a498ebe580278a00679b5',
  name: '微视频'
}, {
  id: '777c2afdb65c45edb54757a2d4a857d7',
  name: '课件'
}, {
  id: 'cd209d29a62d4a8d997ce488f44a50a4',
  name: '教学资源'
}]
export const listData = [{
  'RATING_AVG': '6',
  'DURATION': '1785944',
  'RESOURCE_ID': '7a5e73483d094adebd8df75a062d7bed',
  'RESOURCE_NAME': '初中 七年级 道德与法治 试卷分析',
  'THUMB_PATH': 'resource2/756fd6dd14d24c1ebd8d8ab9bcc283eb/image/20200203/330ac97e0da2453fb0bc177832fc8c32.png',
  'BASE_RESOURCE_SERVER_ID': '001d2fc6e47c42b1a7844ac88d5fd9d1',
  'CREATE_TIME': '3/2/2020 13:27:32',
  'VIEW_CNT': '16491',
  'DOWNLOAD_CNT': '171',
  'CREATE_USER_ID': 'aee6237b052f476b9dce9091b6076903',
  'SERVER_RESOURCE_ID': 'fe393bab0af04614af6f207cdc05a681',
  'RESOURCE_COLUMN': 'video',
  'RESOURCE_EXT': 'mp4',
  'BASE_SEMESTER_ID': '269f5c7bb9ca40a3bd5a4b5ba20c7ad5',
  'BASE_CLASSLEVEL_ID': '2b0411f5fd524e8e89aa4073e915aeb7',
  'BASE_SUBJECT_ID': '03cf65642d5a4a4cb113ab3da925f1a6',
  'BASE_VERSION_ID': 'd4b329f180b3455e83a075cd57bccc57',
  'SERVERADDRESS': 'http://handanwhres.ppms.cn:9000/reserver',
  'REALNAME': '实验中学',
  'CLSSCHOOLID': '',
  'BASEAREAID': '756fd6dd14d24c1ebd8d8ab9bcc283eb',
  'SCHOOLNAME': '',
  'AREANAME': '武安市',
  'USERTYPE': 'AREA_USR',
  'SEMESTERNAME': '初中',
  'CLASSLEVELNAME': '初一',
  'SUBJECTNAME': '道德与法治',
  'VERSIONNAME': '人教版',
}]
